import type { ReactNode } from 'react';
import { Card, CardContent } from '@/shared/components/ui/card';
import { cn } from '@/shared/lib/cn';

export function LoadingPanel({ className }: { className?: string }) {
  return (
    <div className={cn('flex items-center justify-center py-20', className)}>
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-primary border-t-transparent" />
    </div>
  );
}

export function ErrorPanel({ message, className }: { message: string; className?: string }) {
  return (
    <Card className={cn('border-destructive/30', className)}>
      <CardContent className="py-10 text-center">
        <p className="text-sm text-destructive">{message}</p>
      </CardContent>
    </Card>
  );
}

export function EmptyPanel({
  title,
  message,
  action,
  className,
}: {
  title: string;
  message?: string;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <Card className={cn('border-dashed', className)}>
      <CardContent className="py-12 text-center space-y-2">
        <p className="font-medium text-foreground">{title}</p>
        {message ? <p className="text-sm text-muted-foreground">{message}</p> : null}
        {action ? <div className="pt-2">{action}</div> : null}
      </CardContent>
    </Card>
  );
}
